import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { SSHKeyMeta } from "./types";
import type { CreateParams, ImportParams, SSHKeyState } from "./types";

import {
  generateCommonReducers,
  genericInitialState,
} from "@/app/store/utils/slice";

const sshKeySlice = createSlice({
  name: SSHKeyMeta.MODEL,
  initialState: genericInitialState as SSHKeyState,
  reducers: {
    ...generateCommonReducers<SSHKeyState, SSHKeyMeta.PK, CreateParams, void>({
      modelName: SSHKeyMeta.MODEL,
      primaryKey: SSHKeyMeta.PK,
    }),
    import: {
      prepare: (params: ImportParams) => ({
        meta: {
          model: SSHKeyMeta.MODEL,
          method: "import_keys",
        },
        payload: {
          params,
        },
      }),
      reducer: () => {},
    },
    importStart: (state: SSHKeyState, _action: PayloadAction<void>) => {
      state.saved = false;
      state.saving = true;
    },
    importError: (
      state: SSHKeyState,
      action: PayloadAction<SSHKeyState["errors"]>
    ) => {
      state.errors = action.payload;
      state.saving = false;
    },
    importSuccess: (state: SSHKeyState, _action: PayloadAction<void>) => {
      state.errors = null;
      state.saved = true;
      state.saving = false;
    },
  },
});

export const { actions } = sshKeySlice;

export default sshKeySlice.reducer;
